import { render, staticRenderFns } from "./UserTransactionsDialog.vue?vue&type=template&id=6260fe62"
import script from "./UserTransactionsDialog.vue?vue&type=script&lang=js"
export * from "./UserTransactionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports